import React from 'react';

const Footer = () => {
    return <React.Fragment>
        <footer className="text-center mb-2">
        <a href="https://github.com/rrih/cakephp-baked-code-formatter/" className="text-decoration-none">
            GitHub
        </a>
        </footer>
    </React.Fragment>
}

export default Footer;